// Pdf Template Item Component

import React, { Component } from 'react'
import PropTypes from 'prop-types'

import IconButton from '../../../common/common/icon_button/icon_button.jsx'
import IntlMessage from '../../../common/common/intl/intl_message.jsx'
import Input from '../../../common/form/input/input.jsx'
import WysiwygEditor from '../../../common/form/wysiwyg_editor/wysiwyg_editor.jsx'
import Checkbox from '../../../common/form/checkbox/checkbox.jsx'

class MailTemplateItem extends Component {
  static get propTypes () {
    return {
      title: PropTypes.string,
      subjectLabel: PropTypes.string,
      template: PropTypes.object,
      autocompleteOptions: PropTypes.array,
      canAttachTerms: PropTypes.bool,
      onReset: PropTypes.func,
      onFocusEditor: PropTypes.func,
      onChangeAttachTerms: PropTypes.func,
      onChangeincludeAltSupportfooter: PropTypes.func
    }
  }

  static get defaultProps () {
    return {
      title: '',
      subjectLabel: '',
      template: {},
      autocompleteOptions: [],
      canAttachTerms: false,
      onReset: null,
      onFocusEditor: null,
      onChangeAttachTerms: null,
      onChangeincludeAltSupportfooter: null
    }
  }

  render () {
    const {
      title,
      template,
      autocompleteOptions,
      onFocusEditor,
      canAttachTerms
    } = this.props

    return (
      <div className='mailtemplateitem'>
        <div className='content'>
          <h3 className='title'>
            <IntlMessage ident={title} />
          </h3>
          <div className='itemright'>
            <IconButton
              tooltip='common.list.tipRevert'
              tooltipPosition='top'
              icon='header-statusreopen'
              size='normal'
              className='template'
              canHover={false}
              onClick={this._onClickReset.bind(this)}
            />
          </div>
          <div className='input reply'>
            <Input
              type='text'
              name='reply'
              value={template.replyTo}
              label='setting.mailTemplate.replyToEmail'
              size={10}
              onChange={this._onChangeInput.bind(this, 'replyTo')}
            />
          </div>
          <div className='input subject'>
            <Input
              type='text'
              name='subject'
              value={template.subject}
              label={this.props.subjectLabel}
              size={10}
              onChange={this._onChangeInput.bind(this, 'subject')}
            />
          </div>
          <div className='input info'>
            <div className='formcol'>
              <WysiwygEditor
                value={template.content}
                placeholder='setting.mailTemplate.contentPlaceholder'
                hasAutocomplete
                autocompleteChar='['
                autocompleteOptions={autocompleteOptions}
                saveSelection
                onBlur={this._onChangeInput.bind(this, 'content')}
                onFocus={onFocusEditor}
              />
            </div>
          </div>
          <div className='coltermsandcondition'>
            <div className='formfield'>
              <Checkbox
                label='setting.mailTemplate.titleShowTermsandConditionText'
                checked={canAttachTerms}
                icon='common'
                onChange={this._onChangeCheckboxValue.bind(
                  this,
                  !canAttachTerms
                )}
              />
            </div>
          </div>
          <div className='coltermsandcondition'>
            <div className='formfield'>
              <Checkbox
                label='setting.mailTemplate.titleincludeAltSupportfooter'
                checked={template.includeAltSupportfooter}
                icon='common'
                onChange={this._onChangeincludeAltSupportfooter.bind(
                  this,
                  !template.includeAltSupportfooter
                )}
              />
            </div>
          </div>
        </div>
      </div>
    )
  }

  /* Event handler */
  _onClickReset (ev) {
    ev.preventDefault()

    if (this.props.onReset) {
      this.props.onReset()
    }
  }

  _onChangeincludeAltSupportfooter (value) {
    if (this.props.onChangeincludeAltSupportfooter) {
      this.props.onChangeincludeAltSupportfooter(value)
    }
  }

  _onChangeCheckboxValue (value) {
    if (this.props.onChangeAttachTerms) {
      this.props.onChangeAttachTerms(value)
    }
  }

  _onChangeInput (name, value) {
    this.props.template[name] = value
    this.props.template.bDefault = false
  }
}

export default MailTemplateItem
